<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col>
        <div class="text-center mb-3">
          <v-avatar size="150">
            <img alt="user" src="/images/Icon.png" />
          </v-avatar>
        </div>
        <v-card class="mx-auto text-center" max-width="500">
          <v-card-title>
            <div class="text-center mx-auto">
              <div>{{ $t('string.contactingCustomerService') }}</div>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="my-4">
              <v-progress-linear
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              text
              large 
              color="primary" 
              href="https://tuition.hamochigames.com"
            >{{ $t("action.returnHome") }}</v-btn>
            <v-btn 
              large 
              rounded
              color="primary" 
              @click="whatsappUs"
            >{{ $t("action.whatsapp") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* global fbq */
export default {
  data: () => ({
    message: '',
    phone: '60123989864' // Default phone number
  }),
  created() {
    // Get message from URL parameter
    this.message = this.$route.query.message || this.$route.query.msg || '我想了解 Hamochi 数学精进班';
    
    // Get phone from URL parameter, use default if not provided
    this.phone = this.$route.query.phone || '60163989885';
  },
  mounted() {
    // Trigger Pixel Event
    this.trackFB();

    // Redirect to WhatsApp after slight delay (optional)
    setTimeout(() => {
      this.whatsappUs();
    }, 500); // 500ms delay to ensure pixel fires
  },
  methods: {
    trackFB() {
      //BOC: [facebook pixel]
      if (typeof fbq !== 'undefined') {
        fbq('track', 'LeadForTuition');
      }
      //EOC
    },
    whatsappUs() {
      const encodedMessage = encodeURIComponent(this.message);
      window.location.href = `https://wa.me/${this.phone}?text=${encodedMessage}`;
    }
  }
};
</script>